import React from "react";
import Typewriter from "typewriter-effect";

function Typing() {
    return (
        <Typewriter
            options={{
                strings: [
                    "React Native Developer",
                    "Full-Stack Developer (MERN)",
                    "Mobile Application Developer",
                    "React.js / Next.js Specialist",
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 50,
            }}
        />
    );
}

export default Typing;
